<template>
    <div class="value-card">
        <div class="value-metric">
            <span class="value-title">{{title}}</span>
            <span class="measured">mensurado em {{!!litio ? 'mEq/L' : !!percentage ? 'porcentagem' : !!quantivac ? 'RU/ml' : !!tfg ? 'mL/min x 1,73m²' : 'mg/dL'}}</span>
            <div class="value-bar">
                <div class="bar">
                    <template v-for="(label, x) in labels">
                        <div :class="'area ' + label.color" v-bind:key="x">
                            <div class="mark" :style="getMarkPosition(label.interval)" v-if="result.label == label.name">
                                <div class="value-box" :class="getValueColor()">{{result.value}}</div>
                            </div>
                            <div class="limit" v-if="!!label.interval.max">
                                <div class="limit-value">{{label.interval.max}}</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="details">
                    <span class="detail" v-for="(label, x) in labels" v-bind:key="x">
                        {{label.name}}
                    </span>
                </div>
            </div>
        </div>
        <div class="reference">
            <div class="level-box">
                <div class="row">
                    <div class="icon">
                        <font-awesome-icon v-if="['Ótimo', 'Desejável', 'Normal'].includes(result.label)" :icon="['fa', 'check-circle']"/>
                        <font-awesome-icon v-else :icon="['fa', 'exclamation-circle']"/>
                    </div>
                    <div class="level">
                        <!-- <span>Seu nível está</span> -->
                        <span class="level-text " :class="getValueColor()">{{result.label}}</span>
                    </div>
                    <div class="value">
                        {{result.value}} {{!!litio ? 'mEq/L' : !!percentage ? '%' : !!quantivac ? 'RU/ml' : !!tfg ? 'mL/min x 1,73m²' : 'mg/dL'}}
                    </div>
                </div>
                <div class="row">
                    <div class="range">
                        <span>{{getIntervalDesc()}}</span>
                    </div>
                </div>
            </div>
            <!-- <button @click.prevent="$emit('openModal', true, altTitle, result)" class="button btn-primary">O que significa?</button> -->
        </div>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {
        faCheckCircle,
        faExclamationCircle,
    } from '@fortawesome/free-solid-svg-icons'

    library.add(faCheckCircle);
    library.add(faExclamationCircle);

    export default {
        name: "value-card",
        components: { },
        props: {
            title: String,
            altTitle: String,
            result: Object,
            labels: Array,
            litio: false,
            percentage: false,
            quantivac: false,
            tfg: false,
        },
        data() {
            return {

            }
        },
        methods: {
            getMarkPosition(interval) {
                let value = 0;
                let min = 0;
                let max = (interval.max = !!interval.max ? interval.max : interval.min * 2) - interval.min;
                let resultValue = this.result.value - interval.min;
                value = ( resultValue / max ) * 100;
                value = value - 0.5;

                if(value > 99.5)
                    value = 99.5;

                return `left: ${value}%`
            },
            getValueColor() {
                let currentLabel = this.result.label;
                let color = '';
                this.labels.map(label => {
                    if(currentLabel == label.name) 
                        color = label.color;
                });

                return color;
            },
            getIntervalDesc() {
                let currentLabel = this.result.label;
                let interval = '';
                this.labels.map(label => {
                    if(currentLabel == label.name) 
                        interval = label.interval.desc;
                });

                return interval;
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    @import './value-card.scss';
    @import './value-card-responsive.css';
</style>



// WEBPACK FOOTER //
// src/components/KitResults/ValueCard.vue